module.exports = __webpack_public_path__ + "static/media/tentens.50a60e9f.png";